import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { toastr } from '@/utils/toast'

import config from '@/config/config-esm'
import { checkIfLoggedIn } from '@/services/auth'

import { setHome } from '@/store/slices/layoutSlice'

function removeQueryFromString(path) {
  return path.split('?')[0]
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

const InviteForm = ({ inviteToken, setLogin }) => {
  const dispatch = useDispatch()
  const anon = useSelector((state) => state.anon)
  
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    const emailParam = getParameterByName('email')
    if (emailParam) {
      setEmail(emailParam)
    }
  }, [])

  const createUser = (e) => {
    e.preventDefault()
    const data = {
      email,
      password,
      repeatPassword,
      inviteToken: removeQueryFromString(decodeURIComponent(inviteToken))
    }
    axios
      .post(`${config.apiUrl}/accept-invite-and-sign-in`, data)
      .then((r) => {
        const myStorage = window.localStorage
        myStorage.setItem('token', `Bearer ${r.data.data.token}`)
        checkIfLoggedIn({ dispatch })
        dispatch(setHome())
      })
      .catch((e) => {
        console.error('error: ', e)
        toastr.error('Kunne ikke logge inn', `Prøv igjen eller kontakt teamleader`)
      })
  }

  return (
    <form onSubmit={(e) => createUser(e)}>
      <div className="input_wrapper">
        <input
          type="text"
          placeholder="Epost"
          required
          value={email}
          disabled={true}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
        />
      </div>
      <div className="input_wrapper">
        <input
          type="password"
          placeholder="Passord"
          required
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
        />
      </div>
      <div className="input_wrapper">
        <input
          type="password"
          placeholder="Gjenta passord"
          required
          value={repeatPassword}
          onChange={(e) => {
            setRepeatPassword(e.target.value)
          }}
        />
      </div>
      <span>{error}</span>
      <button className="login">Lag bruker</button>
      <div>
        <a
          href=""
          onClick={(e) => {
            e.preventDefault()
            setLogin()
          }}
        >
          Logg inn
        </a>
      </div>
    </form>
  )
}

export default InviteForm
